export const painSliderCopyDe = {
    scoringHint:
        "Vertrauen Sie Ihrem ersten Eindruck - wählen Sie die Zahl, die zu Ihrem Gefühl gerade passt. Nicht zu lange nachdenken.",
};
